import { withTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { Component, createElement, cloneElement } from 'react';
import '../utilities/get-styleprop.js';
import { c as _defineProperty, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Ul } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';
import Pager from './Pager.js';

function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function calculatePage(p, state, props) {
  let pageSize = p;
  if (typeof pageSize === 'undefined') {
    pageSize = state.pageSize;
  }
  return Math.floor((props.total - 1) / pageSize) + 1;
}
class Pagination extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "getJumpPrevPage", () => {
      return Math.max(1, this.state.current - (this.props.showLessItems ? 3 : 5));
    });
    _defineProperty(this, "getJumpNextPage", () => {
      return Math.min(calculatePage(undefined, this.state, this.props), this.state.current + (this.props.showLessItems ? 3 : 5));
    });
    _defineProperty(this, "savePaginationNode", node => {
      this.paginationNode = node;
    });
    _defineProperty(this, "isValid", page => {
      return isInteger(page) && page !== this.state.current;
    });
    _defineProperty(this, "handleChange", p => {
      const {
        disabled
      } = this.props;
      let page = p;
      if (this.isValid(page) && !disabled) {
        const currentPage = calculatePage(undefined, this.state, this.props);
        if (page > currentPage) {
          page = currentPage;
        } else if (page < 1) {
          page = 1;
        }
        if (!('current' in this.props)) {
          this.setState({
            current: page
          });
        }
        const {
          pageSize
        } = this.state;
        this.props.onChange(page, pageSize);
        return page;
      }
      return this.state.current;
    });
    _defineProperty(this, "prev", () => {
      if (this.hasPrev()) {
        this.handleChange(this.state.current - 1);
      }
    });
    _defineProperty(this, "next", () => {
      if (this.hasNext()) {
        this.handleChange(this.state.current + 1);
      }
    });
    _defineProperty(this, "jumpPrev", () => {
      this.handleChange(this.getJumpPrevPage());
    });
    _defineProperty(this, "jumpNext", () => {
      this.handleChange(this.getJumpNextPage());
    });
    _defineProperty(this, "hasPrev", () => {
      return this.state.current > 1;
    });
    _defineProperty(this, "hasNext", () => {
      return this.state.current < calculatePage(undefined, this.state, this.props);
    });
    _defineProperty(this, "runIfEnter", (event, callback, ...restParams) => {
      if (event.key === 'Enter' || event.charCode === 13) {
        callback(...restParams);
      }
    });
    _defineProperty(this, "runIfEnterPrev", event => {
      this.runIfEnter(event, this.prev);
    });
    _defineProperty(this, "runIfEnterNext", event => {
      this.runIfEnter(event, this.next);
    });
    _defineProperty(this, "runIfEnterJumpPrev", event => {
      this.runIfEnter(event, this.jumpPrev);
    });
    _defineProperty(this, "runIfEnterJumpNext", event => {
      this.runIfEnter(event, this.jumpNext);
    });
    let current = props.defaultCurrent;
    if ('current' in props) {
      current = props.current;
    }
    let _pageSize = props.defaultPageSize;
    if ('pageSize' in props) {
      _pageSize = props.pageSize;
    }
    this.state = {
      current,
      pageSize: _pageSize
    };
  }
  static getDerivedStateFromProps(props, prevState) {
    const newState = {};
    if ('current' in props) {
      newState.current = props.current;
    }
    if ('pageSize' in props && props.pageSize !== prevState.pageSize) {
      let {
        current
      } = prevState;
      const newCurrent = calculatePage(props.pageSize, prevState, props);
      current = current > newCurrent ? newCurrent : current;
      if (!('current' in props)) {
        newState.current = current;
      }
      newState.pageSize = props.pageSize;
    }
    return newState;
  }
  render() {
    const {
      total,
      showLessItems,
      itemRender,
      theme
    } = this.props;
    if (total <= this.state.pageSize) {
      return null;
    }
    const allPages = calculatePage(undefined, this.state, this.props);
    const pagerList = [];
    let jumpPrev = null;
    let jumpNext = null;
    let firstPager = null;
    let lastPager = null;
    const pageBufferSize = showLessItems ? 1 : 2;
    const {
      current
    } = this.state;
    const dataOrAriaAttributeProps = Object.keys(this.props).reduce((prev, key) => {
      if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') {
        prev[key] = this.props[key];
      }
      return prev;
    }, {});
    if (allPages <= 5 + pageBufferSize * 2) {
      const pagerProps = {
        itemRender,
        onClick: this.handleChange
      };
      if (!allPages) {
        pagerList.push(/*#__PURE__*/createElement(Pager, _extends({}, pagerProps, {
          key: "noPager",
          page: allPages
        })));
      }
      for (let i = 1; i <= allPages; i++) {
        const active = this.state.current === i;
        pagerList.push(/*#__PURE__*/createElement(Pager, _extends({}, pagerProps, {
          key: i,
          page: i,
          active: active
        })));
      }
    } else {
      jumpPrev = /*#__PURE__*/createElement(Button, {
        key: "prev",
        tabIndex: 0,
        onClick: this.jumpPrev,
        onKeyPress: this.runIfEnterJumpPrev,
        iconProps: {
          glyph: icons.DOTS_HORIZONTAL,
          size: 16
        },
        small: true,
        variant: "tertiary",
        styles: {
          root: {
            mr: `${theme.spacing.xs}px`
          }
        }
      });
      jumpNext = /*#__PURE__*/createElement(Button, {
        key: "next",
        tabIndex: 0,
        onClick: this.jumpNext,
        onKeyPress: this.runIfEnterJumpNext,
        iconProps: {
          glyph: icons.DOTS_HORIZONTAL,
          size: 16
        },
        small: true,
        variant: "tertiary",
        styles: {
          root: {
            mr: `${theme.spacing.xs}px`
          }
        }
      });
      lastPager = /*#__PURE__*/createElement(Pager, {
        onClick: this.handleChange,
        onKeyPress: this.runIfEnter,
        key: allPages,
        page: allPages,
        active: false,
        itemRender: itemRender
      });
      firstPager = /*#__PURE__*/createElement(Pager, {
        onClick: this.handleChange,
        onKeyPress: this.runIfEnter,
        key: 1,
        page: 1,
        active: false,
        itemRender: itemRender
      });
      let left = Math.max(1, current - pageBufferSize);
      let right = Math.min(current + pageBufferSize, allPages);
      if (current - 1 <= pageBufferSize) {
        right = 1 + pageBufferSize * 2;
      }
      if (allPages - current <= pageBufferSize) {
        left = allPages - pageBufferSize * 2;
      }
      for (let i = left; i <= right; i++) {
        const active = current === i;
        pagerList.push(/*#__PURE__*/createElement(Pager, {
          onClick: this.handleChange,
          onKeyPress: this.runIfEnter,
          key: i,
          page: i,
          active: active,
          itemRender: itemRender
        }));
      }
      if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
        pagerList[0] = /*#__PURE__*/cloneElement(pagerList[0]);
        pagerList.unshift(jumpPrev);
      }
      if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
        pagerList[pagerList.length - 1] = /*#__PURE__*/cloneElement(pagerList[pagerList.length - 1]);
        pagerList.push(jumpNext);
      }
      if (left !== 1) {
        pagerList.unshift(firstPager);
      }
      if (right !== allPages) {
        pagerList.push(lastPager);
      }
    }
    const prevDisabled = !this.hasPrev() || !allPages;
    const nextDisabled = !this.hasNext() || !allPages;
    return /*#__PURE__*/createElement(Ul, _extends({
      display: "flex",
      m: 0
      // @ts-ignore
      ,
      elRef: this.savePaginationNode
    }, dataOrAriaAttributeProps), /*#__PURE__*/createElement(Button, {
      onClick: this.prev,
      tabIndex: prevDisabled ? null : 0,
      onKeyPress: this.runIfEnterPrev,
      disabled: prevDisabled,
      "aria-disabled": prevDisabled,
      iconProps: {
        glyph: icons.CHEVRON_DOWN,
        rotate: 90,
        size: 16
      },
      small: true,
      variant: "tertiary",
      styles: {
        root: {
          mr: `${theme.spacing.xs}px`
        }
      }
    }), pagerList, /*#__PURE__*/createElement(Button, {
      onClick: this.next,
      tabIndex: nextDisabled ? null : 0,
      onKeyPress: this.runIfEnterNext,
      disabled: nextDisabled,
      "aria-disabled": nextDisabled,
      iconProps: {
        glyph: icons.CHEVRON_DOWN,
        rotate: -90,
        size: 16
      },
      small: true,
      variant: "tertiary",
      styles: {
        root: {}
      }
    }));
  }
}
_defineProperty(Pagination, "defaultProps", {
  defaultCurrent: 1,
  total: 0,
  defaultPageSize: 10,
  showLessItems: false,
  onChange: () => ({}),
  itemRender: (_, _1, element) => element
});
var Pagination$1 = withTheme(Pagination);

export default Pagination$1;
